import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface GroupLineProps {
  label: string;
  className?: string;
}

/**
 * 월별 구분선과 라벨을 표시하는 컴포넌트
 */
export const GroupLine = t0 => {
  const $ = _c(9);
  const {
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex h-16 items-center gap-12", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-1 flex-1 bg-Gray-200" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <span className="whitespace-nowrap font-600 text-Gray-500 typo-caption2">{label}</span>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="h-1 flex-1 bg-Gray-200" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t3) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};